


const Refund=()=>{
     
    return(
        <div className="container p-5">
<div>
 <h2><b>CANCELLATION POLICY</b></h2>
</div>
<p>Cancellations on coffee orders will be considered if the request is made before delivery slips are generated.</p>
<div>
<h2><b>RETURNS AND REFUND POLICY</b></h2>
</div>

<p>If you are unsatisfied with any coffee purchase please write to us at gayathricoffee2015@gmail.com.in with your order details to understand the issue. Refunds and Replacements will be done on a case to case basis.</p>
<div>
<h2><b>PLEASE NOTE</b></h2>
</div>
<p>
1. All brewing equipment can only be refunded if it is returned back to us in new and unused condition

2. Refunds claim if accepted are initiated within 5 days of notification. The amount of time it takes before the money is credited back will be as per the bank cycle
</p>
</div>
    )
}
export default Refund;